import api from ".";
import { submissionEndpoints } from "./endpoints/submission.endpoints";

export const submissionApis = {
  submitForSchema: async (schemaId, data) => {
    try {
      const res = await api.post(submissionEndpoints.submit(schemaId), data);
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error submitting form");
    }
  },

  getAllSubmissions: async (params = {}) => {
    try {
      const { sector, schemaId, limit, page } = params;
      const queryParams = new URLSearchParams();
      if (sector) queryParams.append("sector", sector);
      if (schemaId) queryParams.append("schemaId", schemaId);
      if (limit) queryParams.append("limit", limit);
      if (page) queryParams.append("page", page);

      const queryString = queryParams.toString();
      const url = queryString
        ? `${submissionEndpoints.getAll}?${queryString}`
        : submissionEndpoints.getAll;

      const res = await api.get(url);
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching submissions");
    }
  },

  getSubmissionById: async (id) => {
    try {
      const res = await api.get(submissionEndpoints.getById(id));
      return res.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching submission");
    }
  },

  getSubmissionsBySector: async (sector) => {
    try {
      const encodedSector = encodeURIComponent(sector);
      const res = await api.get(submissionEndpoints.getBySector(encodedSector));
      return Array.isArray(res.data) ? res.data : (res.data?.data || res.data || []);
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching submissions by sector");
    }
  },

  getSubmissionsByReport: async (reportId) => {
    try {
      const res = await api.get(submissionEndpoints.getByReport(reportId));
      return Array.isArray(res.data) ? res.data : (res.data?.data || res.data || []);
    } catch (error) {
      throw new Error(error.response?.data?.message || "Error fetching submissions by report");
    }
  },
};

